import { render, staticRenderFns } from "./HeroFull.vue?vue&type=template&id=02347501&"
import script from "./HeroFull.vue?vue&type=script&lang=js&"
export * from "./HeroFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports